import { create } from 'zustand';
import type { CropData, ProductionStatus, ProductCategory, Product } from '@/types';
import type { AppStep } from '@/types/app';

interface ProductStore {
  step: AppStep;
  masterImage: File | null;
  productTitle: string;
  productCategory: ProductCategory;
  crops: CropData[];
  productionStatus: ProductionStatus;
  productionProgress: number;
  currentProduct: Product | null;

  setStep: (step: AppStep) => void;
  setMasterImage: (file: File | null) => void;
  setProductTitle: (title: string) => void;
  setProductCategory: (category: ProductCategory) => void;
  setCrops: (crops: CropData[]) => void;
  setProductionStatus: (status: ProductionStatus) => void;
  setProductionProgress: (progress: number) => void;
  setCurrentProduct: (product: Product | null) => void;

  reset: () => void;
}

const initialState = {
  step: 'dashboard' as AppStep,
  masterImage: null as File | null,
  productTitle: '',
  productCategory: 'digital-art-print' as ProductCategory,
  crops: [] as CropData[],
  productionStatus: 'IDLE' as ProductionStatus,
  productionProgress: 0,
  currentProduct: null as Product | null,
};

export const useProductStore = create<ProductStore>((set) => ({
  ...initialState,

  setStep: (step) => set({ step }),
  setMasterImage: (masterImage) => set({ masterImage }),
  setProductTitle: (productTitle) => set({ productTitle }),
  setProductCategory: (productCategory) => set({ productCategory }),
  setCrops: (crops) => set({ crops }),
  setProductionStatus: (productionStatus) => set({ productionStatus }),
  setProductionProgress: (productionProgress) => set({ productionProgress }),
  setCurrentProduct: (currentProduct) => set({ currentProduct }),

  reset: () => set(initialState),
}));
